import * as screenfull from 'screenfull';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CustomMessages, EasyDialog } from '@shared';

import { ComboPopulation } from 'app/model/combo-population';
import { CommonDTO } from 'app/model/common-dto';
import { CommonService } from 'app/service/common.service';
import { DomSanitizer } from '@angular/platform-browser';
//import { HeaderService } from 'app/service/header-component.service';
import { ProcessService } from './../../../shared/service/process.service';
import { Router } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { OverlayModule } from '@angular/cdk/overlay';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TranslatePipe],
})
export class HeaderComponent implements OnInit {
  selectAction: any;
  openedwriteus: boolean = false;
  openedrelease = false;
  openWriteUsPage: boolean = false;
  userName: string = '';
  emailId: string = '';
  userTeamType: string;
  @Input() showToggle = true;
  @Input() showBranding = false;
  @Input() domain: any;
  @Input() userid: any;

  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleSidenavNotice = new EventEmitter<void>();
  commonDto: CommonDTO = new CommonDTO();
  clientList: ComboPopulation[];
  showSelectedClient: string;
  CLIENT_LIST = 'clientList';
  USER_NAME = 'authenticatedUser';
  thumbnailAvatar: any;
  parsedJson: any;
  openedprivacy: boolean = false;
  @ViewChild('triggerElement', { static: true }) trigger!: ElementRef;
  isMenuOpen: boolean = false;
  dbLabel: string = '';

  private get screenfull(): screenfull.Screenfull {
    return screenfull as screenfull.Screenfull;
  }

  constructor(
    private commonService: CommonService,
    private sidebarComponent: SidebarComponent,
    private customMessage: CustomMessages,
    private cdfRef: ChangeDetectorRef,
    public dialog: EasyDialog,
    private ts: TranslatePipe,
    private router: Router,
    private sanitizer: DomSanitizer
  ) { }

  commonDTO: CommonDTO = new CommonDTO();

  ngOnInit() {
    this.getClientListByUserId();
    const dbName = localStorage.getItem('dbName');

    if (!dbName || dbName === 'undefined') {
      this.dbLabel = '';
    } else {
      this.dbLabel = dbName;
    }

  }

  toggleFullscreen() {
    if (this.screenfull.enabled) {
      this.screenfull.toggle();
    }
  }

  g

  downloadManual() {
    this.userTeamType = localStorage.getItem('userTeamType');
    this.commonDTO.userType = this.userTeamType;
    this.commonService.exportPowerPoint(this.commonDTO).subscribe(
      data => {
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        if (this.userTeamType == 'Auditee Area')
          link.download = 'CAMS_User_Guide_For_Auditee' + '.ppsx';
        else link.download = 'CAMS_User_Guide_For_Auditor' + '.ppsx';
        link.click();
      },
      error => {
        if (error.error.msgId == undefined || error.error.msgId == '') {
          error.error.msgId = 'cams.label.common.errorOccuredInOperation';
          this.customMessage.showErrorMessage(error.error.msgId, '');
        } else {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      }
    );
  }

  feedbackForm() {
    this.commonDto.userEmail = localStorage.getItem('email');
    this.commonService.redirectToFeedbackForm(this.commonDto).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        window.open(this.parsedJson);
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  setClientSelection() {
    /* this.headerService.setClientSelection(this.showSelectedClient)
    .subscribe((data: any) => {

      //this.cdfRef.detectChanges();
      this.sidebarComponent.showHideLoader(false);
    }, (error) => {
      this.sidebarComponent.showHideLoader(false);
      this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
    }); */
  }

  getClientListByUserId() {
    /*    this.sidebarComponent.showHideLoader(true);
       this.commonService.getClientListByUserId(this.commonDto)
         .subscribe((data: any) => {
   
           this.clientList = data;
           this.showSelectedClient=this.clientList[0].id.toString();
           
           this.cdfRef.detectChanges();
           this.setClientSelection();
           this.sidebarComponent.showHideLoader(false);
         }, (error) => {
           this.sidebarComponent.showHideLoader(false);
           this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
         }); */

    this.clientList = JSON.parse(localStorage.getItem('clientList'));
    this.showSelectedClient = this.clientList[0].id.toString();
    this.userName = localStorage.getItem('authenticatedUser');
    this.userName = this.userName.toString();
    this.cdfRef.detectChanges();
    localStorage.setItem('showSelectedClient', this.showSelectedClient);
  }
  getClientImage() {
    /*
    this.emailId = localStorage.getItem("email");
    let image;
    this.commonService.getUserImageByEmail(this.emailId).subscribe((data:any) => {
      let objectURL = 'data:image/png;base64,' + data;
      image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      // let objectURL = URL.createObjectURL(blob);
  })*/
  }

  writeus() {
    this.openedwriteus = !this.openedwriteus;
    this.openWriteUsPage = true;
  }

  closedwriteus(evt) {
    this.openedwriteus = evt;
    this.openWriteUsPage = false;
  }

  logOutConfirmation() {
    let obj = this;
    obj.dialog.confirm(
      obj.ts.transform('cams.label.common.confirm'),
      obj.ts.transform('cams.label.header.confirmationToLogout'),
      async function () {
        obj.logOut();
        //dialogRef.disableClose = true;
      },
      function () {
        //ACTION: Do this if user says NO
        //that.name = "No clicked";
      }
    );
  }

  logOut() {
    var token = localStorage.getItem('token');
    if (token) {
      this.commonService.logout(token).subscribe((data: any) => {
        if (data == '1') {
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['/login']);
        }
      });
    } else {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login']);
    }
  }

  releasehistory() {
    this.openedrelease = !this.openedrelease;
  }

  closedhistory() {
    this.openedrelease = false;
  }

  releaseprivacy() {
    this.openedprivacy = !this.openedprivacy;
  }

  closedprivacy() {
    this.openedprivacy = false;
  }
}
